import { render, staticRenderFns } from "./edit-position.vue?vue&type=template&id=0582b05e&"
import script from "./edit-position.vue?vue&type=script&lang=js&"
export * from "./edit-position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports